<div
  class="notification"
  [class]="type"
  [ngClass]="{ inline }"
  role="alert"
  [matTooltip]="tooltip"
  [matTooltipDisabled]="tooltipDisabled"
  [attr.aria-live]="type === 'error' ? 'assertive' : 'polite'"
>
  @if (type === 'error' && (error || title)) {
    @if (title) {
      <span>{{ title }}{{ error?.message ? ':&nbsp;' : '' }}</span>
    }
    @if (error) {
      <span>{{ error.message }}</span>
    }
  }
  @if (message) {
    <span class="notification-message">{{ message }}</span>
  }

  <ng-content></ng-content>
</div>
